import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import ClientForm from "../components/ClientForm";
import Preloader from "../components/Preloader";
import {
  loadClient,
  removeClient, editCardRequest, loadClientAction, editCardError,
} from "../actions/clientsActions";
import { CLIENT } from "../constants/routes";
import {
  parseUrl,
  translateServerError,
  prepareUsersForSelect, createRedirectUrlFromType
} from "../helpers/core";
import { loadUsers } from "../actions/userActions";
import { updateTableOfChanging } from "../actions/updateTableOfChanging";
import editCardHttpHandler, {
  Contact,
  EditCardRequest, GrainVolume
} from "../apiClient/Card/Edit";

class SupplierDetailPage extends Component {
  state = {
    isRemoved: false
  };

  id = this.props.location.search && parseUrl(this.props.location.search).id;

  componentWillMount() {
    if (this.id) {
      this.props.loadClient(this.id);
    }
    this.props.loadUsers();
  }

  onClientChange = data => {
    this.props.changeClient(data);
  };

  onClientRemove = () => {
    if (
      !window.confirm(
        "Вы уверены, что хотите удалить Клиента? Действие необратимо"
      )
    )
      return;
    this.props.removeClient(this.id);
    this.setState({
      isRemoved: true
    });
  };

  render() {
    if (!this.id) {
      return (
        <div className="container">
          <h4>Некорректный адрес.</h4>
          <p>
            Рекомендуем перейти к <Link to={CLIENT}>списку клиентов</Link>.
          </p>
        </div>
      );
    }

    const {
      loading,
      client,
      initData,
      error,
      priceUpdating,
      modules,
      users,
      updateTableOfChanging,
      changes
    } = this.props;
    const userForSelect = users.length ? prepareUsersForSelect(users) : [];

    if (loading) {
      return <Preloader />;
    }

    if (!loading && !client) {
      return (
        <div className="container">
          <h4>
            {this.state.isRemoved
              ? "Клиент успешно удален."
              : "Данные по клиенту не найдены."}
          </h4>
          <p>
            Перейти к <Link to={CLIENT}>списку клиентов</Link>.
          </p>
        </div>
      );
    }

    if (client.type !== 2) {
      window.location.href = createRedirectUrlFromType(
          client.id,
          parseInt(client.type)
      );
    }

    const type = initData.client_type.find(el => el.label === "Клиент");
    return (
      <ClientForm
        isEditMode
        client={client}
        initData={initData}
        moveCultureToHistory={() => {}}
        type={type ? type.value : ""}
        onSubmit={this.onClientChange}
        onRemove={this.onClientRemove}
        serverError={error}
        priceUpdating={priceUpdating}
        showCalleeAsign={modules.assign_call}
        showDeleteAction={modules.can_delete}
		showInWorkButton={false}
		showCancelInWorkButton={false}
        users={userForSelect}
        updateTableOfChanging={updateTableOfChanging}
        changes={changes}
      />
    );
  }
}
const editCard = (dispatch, data) => {

  dispatch(editCardRequest);

  editCardHttpHandler.edit(data.client.id, new EditCardRequest(
      data.client.type || null,
      data.client.name || null,
      data.client.email || null,
      data.client.address || null,
      data.client.lat || null,
      data.client.lon || null,
      data.client.geo_id || null,
      data.client.area_full || null,
      data.client.will_callee_id || null,
      data.client.date_will_call || null,
      data.client.call_aim || null,
      data.client.additional_info || null,
      data.client.contract || false,
      data.client.vat || 1,
      data.client.websites,
      data.client.filials.map((filialData) => filialData.id),
      data.client.categories,
      data.client.contacts.map((contactData) => new Contact(
          contactData.name,
          contactData.phone,
          contactData.email,
          contactData.isVisible,
      )),
      data.client.cultures.map((grainData) => new GrainVolume(
          grainData.culture_id,
          grainData.price,
          grainData.volume,
          grainData.quality_comment,
      )),
      data.client.date_called || null
      )
  ).subscribe(
      (response) => {
        loadClientAction(data.client.id, dispatch);
      },
      (error) => {
        dispatch(editCardError(error.error.join("\n")));
      })
}

SupplierDetailPage.propTypes = {
  client: PropTypes.object,
  location: PropTypes.object,
  initData: PropTypes.object,
  loading: PropTypes.bool,
  priceUpdating: PropTypes.bool,
  loadClient: PropTypes.func.isRequired,
  changeClient: PropTypes.func.isRequired,
  removeClient: PropTypes.func.isRequired,
  loadUsers: PropTypes.func.isRequired,
  updateTableOfChanging: PropTypes.func.isRequired,
  error: PropTypes.string,
  modules: PropTypes.object,
  users: PropTypes.array
};

const mapStateToProps = state => ({
  changes: state.changing.dataOfChanging,
  client: state.clients.list[0],
  loading: state.clients.loading,
  initData: state.webInterface.initData,
  priceUpdating: state.clients.priceUpdating,
  error: translateServerError(state.clients.error),
  modules: state.webInterface.initData
    ? state.webInterface.initData.available_modules
    : {},
  users: state.users.list
});

const mapDispatchToProps = dispatch => ({
  loadClient: id => dispatch(loadClient(id)),
  changeClient: data => editCard(dispatch, data),
  removeClient: id => dispatch(removeClient(id)),
  loadUsers: () => dispatch(loadUsers()),
  updateTableOfChanging: id => dispatch(updateTableOfChanging(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupplierDetailPage);



// WEBPACK FOOTER //
// ./containers/ClientDetailPage.js